import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Paper,
  Typography,
  Backdrop,
  Fade,
  useTheme,
  useMediaQuery,
  TextField,
  Grid,
  IconButton,
  Button
} from '@mui/material';
import { CustomButton } from '@buttons/CustomButton';
import { useTokenStore } from '@store/TokenStore';
import { getDataPromotion, getPromotion } from '@api/getPromotions';
import { usePromotionStore } from '@store/promotionStore';
import { usePolicyStore } from '@store/policyStore';
import { useCarStore } from '@store/carInfoStore';
import { useDriverStore } from '@store/driverInfoStore';
import TagManager from 'react-gtm-module';
import CountdownTimer from '@modals/modalpromotions/components/CountdownTimer';
import { useSendContacts } from '@hooks/useSendContacts';
import { upCRM } from '@utils/CRM';
import { useSelectedQuoteStore } from '@store/QuoteStore';
import { useTrackingStore } from '@store/TrackingStore';
import { useCPStore } from '@store/cpStore';
import { getTracking } from '@api/getTracking';
import { useCarListStore } from '@store/carListStore';
import { Link } from 'react-router-dom';
import { validateEmail } from '@utils/utilityFunctions';
import { useClamp } from '@utils/useClamp';
import { Check, Close, Edit } from '@mui/icons-material';

type ModalHomeProps = {
  onClose: () => void;
};

export const ModalCardPromotion: React.FC<ModalHomeProps> = ({ onClose }) => {
  const [editEmail, setEditEmail] = useState(false);
  const [errorEmail, setErrorEmail] = useState({
    msg: '',
    isError: false,
  });
  const {
    infoPromotion,
    dataPromo,
    select,
    sendPromotion,
    setPromotion,
    setChooseSelected,
  } = usePromotionStore();
  const { token } = useTokenStore();
  const [data, setData] = useState<{
    id: string;
    title: string;
    description: string;
    code: string;
    total: number;
    start_at: any;
    end_at: any;
    promo_picture: string;
    doc_name: string;
    type_promotion: string;
    amount: number;
    updated_by: string;
    created_by: string;
    updated_at: string;
    created_at: string;
  }>({
    id: '',
    title: '',
    description: '',
    code: '',
    total: 0,
    start_at: 0,
    end_at: 0,
    promo_picture: '',
    doc_name: '',
    type_promotion: '',
    amount: 0,
    updated_by: '',
    created_by: '',
    updated_at: '',
    created_at: '',
  });
  const policy = usePolicyStore();
  const { addPolicyInfo } = usePolicyStore();
  const car = useCarStore();
  const driver = useDriverStore();
  const { selectedQuote } = useSelectedQuoteStore();
  const { tracking } = useTrackingStore();
  const { cpData } = useCPStore();
  const { carList } = useCarListStore();
  const {clamp} = useClamp()
  const [email, setEmail] = useState(driver.driver.email);
  const [tempEmail, setTempEmail] = useState(driver.driver.email)

  const DataLayer = {
    event: 'CSform_Modal_Amazon',
    eventCategory: 'Formulario.Seguro.Auto.v2',
    eventAction: 'promoción_amazon_view',
    eventLabel: undefined,
    telefono: driver.driver.telefono,
    correo: driver.driver.email,
    noCotizacion: policy.policy.policyNumber,
    modelo: car.car.description,
    marca: car.car.assembler,
    anio: car.car.model,
    paquete: undefined,
    forma_pago: undefined,
    aseguradora: undefined,
    tarjeta: undefined,
    tipo_tarjeta: undefined,
    tipo_vehiculo: car.car.type,
    colaborador: undefined,
    cupon: undefined,
  };

  const tagManagerArgs = {
    dataLayer: DataLayer,
  };

  const SendDataLayer = {
    event: 'CSform_Modal_Amazon',
    eventCategory: 'Formulario.Seguro.Auto.v2',
    eventAction: 'promoción_amazon_select',
    eventLabel: 'correo electrónico',
    telefono: driver.driver.telefono,
    correo: driver.driver.email,
    noCotizacion: policy.policy.policyNumber,
    modelo: car.car.description,
    marca: car.car.assembler,
    anio: car.car.model,
    paquete: undefined,
    forma_pago: undefined,
    aseguradora: undefined,
    tarjeta: undefined,
    tipo_tarjeta: undefined,
    tipo_vehiculo: car.car.type,
    colaborador: undefined,
    cupon: undefined,
  };

  const SendManagerLayer = {
    dataLayer: SendDataLayer,
  };

  useEffect(() => {
    TagManager.dataLayer(tagManagerArgs);
    (async () => {
      const resp = await getPromotion(token);
      setData(resp);
      setPromotion({ ...infoPromotion, ...resp });
    })();
  }, []);

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "coche_seguro_cupon_nocturno_v",
        no_cotizacion: policy.policy.policyNumber,
        page_url: window.location.href,
        hora: new Date().getHours(),
        correo: email,
      }
    })
  }, [])

  const sendTracking = async () => {
    let initialData = {
      id: tracking.id,
      business: 'cocheseguro',
      data: {
        car: car.car,
        driver: driver.driver,
        selectedQuote: selectedQuote,
        policy: policy.policy,
        cpData: cpData,
        carList: carList,
      },
    };
    await getTracking(token, initialData);
  };

  const sendUpCRM = () => {
    upCRM(
      token,
      car.car,
      driver.driver,
      selectedQuote,
      policy.policy,
      tracking,
      cpData
    );
    sendTracking();
  };
  const { postSendContacts } = useSendContacts();

  const onSend = () => {
    postSendContacts();
    sendUpCRM();
  };

  const colorHelperTextMail = () => {
    if (errorEmail.isError) {
      return '#f44336';
    }
  };

  const handleInputChange = (value: string) => {
    setTempEmail(value);
    
    if (validateEmail(value)) {
      setErrorEmail({
        msg: '',
        isError: false,
      });
    } else {
      setErrorEmail({
        msg: '¡Oh, no! Debes ingresar un correo válido.',
        isError: true,
      });
    }
  };

  const handleGet = async () => {
    TagManager.dataLayer(tagManagerArgs)
    TagManager.dataLayer({
      dataLayer: {
        event: 'coche_seguro_cupon_nocturno', //Static data
        no_cotizacion: policy.policy.policyNumber,
        page_url: window.location.href,
        hora: new Date().getHours(),
        boton_contacto: 'Quiero mi cupón!',
        correo: email,
      },
    });
    const sendTracking = async () => {
      let initialData = {
        id: tracking.id,
        business: 'cocheseguro',
        data: {
          car: car.car,
          driver: driver.driver,
          selectedQuote: selectedQuote,
          policy: policy.policy,
          cpData: cpData,
          carList: carList,
        },
      };
      await getTracking(token, initialData);
    };

    let data = {
      name: driver.driver.name,
      promotion_id: infoPromotion.id,
      email: email,
      folio: policy.policy.policyNumber,
    };

    let res = await getDataPromotion(token, data);
    infoPromotion.code = res.data.promotion_code;
    policy.policy.codeCoupon = infoPromotion;
    addPolicyInfo({ ...policy.policy, acceptCoupon: '1' });
    sendPromotion({ ...dataPromo, ...data });
    setPromotion({ ...infoPromotion });
    setChooseSelected({ ...select, selected: 'Correo electrónico' });
    upCRM(
      token,
      car.car,
      driver.driver,
      selectedQuote,
      policy.policy,
      tracking,
      cpData
    );
    sendTracking();
    onClose();
  };

  return (
    <Modal
      sx={{
        zIndex: 10001,
      }}
      open
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in>
        <Paper
          style={{
            borderRadius: 8,
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
            overflowX: 'hidden',
            backgroundColor: 'white',
            top: '50%',
            left: '50%',
            margin: 'auto',
            width: clamp('461px', '461px', '327px'),
            height: 'auto',
          }}
        >
          <Box>
            <div style={{
              backgroundImage: `url(${data?.promo_picture})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              paddingBottom: '62.5%',
              backgroundRepeat: 'no-repeat'
            }}></div>
            <Box sx={{ 
              padding: '1rem',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
              {policy.policy.endDateTime !== '' && (
                <CountdownTimer endDateTime={policy.policy.endDateTime} />
              )}
              <Typography sx={{ marginTop: '1rem', textAlign: 'center', fontSize: '14px', fontWeight: '400', color: '#212121' }}>
                Te enviaremos tu cupón de promoción a:
              </Typography>
              { editEmail ? (
                <Grid container sx={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'nowrap' }}>
                  <Grid item marginRight={'1rem'}>
                    <TextField
                      id="email"
                      fullWidth
                      value={tempEmail}
                      variant="outlined"
                      placeholder="Correo electrónico"
                      onChange={(event) => handleInputChange(event?.target.value)}
                      error={errorEmail.isError}
                      helperText={
                        <label style={{ color: colorHelperTextMail() }}>
                          {errorEmail.msg}
                        </label>
                      }
                    />
                  </Grid>
                  <Grid item marginRight={'0.5rem'}>
                    <Button disabled={errorEmail.isError} onClick={() => {
                        setEmail(tempEmail)
                        setEditEmail(false)
                      }} variant='contained' color='primary' sx={{ minWidth: '40px', height: '40px', padding: 0 }}>
                      <Check fontSize='large' />
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button onClick={() => {
                        setTempEmail(email)
                        setEditEmail(false)
                        setErrorEmail({
                          msg: '',
                          isError: false
                        })
                      }} variant='outlined' color='primary' sx={{ minWidth: '40px', height: '40px', padding: 0 }}>
                      <Close fontSize='large' />
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', columnGap: '8px' }}>
                  <Typography sx={{ fontSize: '14px', color: '#42B6D9' }}>{ email }</Typography>
                  <span onClick={() => setEditEmail(true)}>
                    <Edit sx={{ fontSize: '18px', cursor: 'pointer', color: '#42B6D9' }} />
                  </span>
                </Box>
              )}
              <Typography
                fontWeight={400}
                fontSize={14}
                textAlign={'center'}
                color="#212121"
                marginTop={'1rem'}
              >
                Tendrás que ingresar el código al finalizar tu compra para hacerlo válido
              </Typography>
              <Typography variant={'subtitle2'} sx={{ marginY: '1rem' }}>
                  {'Ver'}
                  &nbsp;
                  <Link
                    style={{
                      color: '#039ECC',
                      textDecoration: 'none'
                    }}
                    to={{
                      pathname: 'https://inter.mx/terminos-condiciones',
                    }}
                    onClick={() => {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: 'coche_seguro_cupon_nocturno_terminos', //Static data
                          no_cotizacion: policy.policy.policyNumber,
                          page_url: window.location.href,
                          hora: new Date().getHours(),
                          boton_contacto: 'Terminos y Condiciones',
                          correo: email,
                        },
                      });
                    }}
                    target="_blank"
                  >
                    Términos y Condiciones
                  </Link>
                </Typography>
              <CustomButton
                text="¡QUIERO MI CUPÓN!"
                disabled={errorEmail.isError}
                onClick={handleGet}
                color={'primary'}
                variant={'contained'}
                style={{
                  height: '48px',
                  width: '100%',
                  textTransform: 'none',
                  marginBottom: '0.5rem',
                }}
              />
              <CustomButton
                text="NO POR AHORA"
                onClick={() => {
                  SendDataLayer.eventLabel = 'talVezDespués';
                  TagManager.dataLayer(SendManagerLayer);
                  TagManager.dataLayer({
                    dataLayer: {
                      event: 'coche_seguro_cupon_nocturno',
                      no_cotizacion: policy.policy.policyNumber,
                      page_url: window.location.href,
                      hora: new Date().getHours(),
                      boton_contacto: 'No por ahora',
                      correo: email,
                    },
                  });
                  policy.policy.acceptCoupon = '0';
                  addPolicyInfo({ ...policy.policy });
                  onSend();
                  onClose();
                }}
                color={'primary'}
                variant={'text'}
                style={{
                  height: '48px',
                  width: '100%',
                  textTransform: 'none',
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
